import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

import { AppConfig } from './../../app/app.config';
import { PageDefault } from '../PageDefault';
import { LotteryModel } from '../../models/lottery.model';
import { StorageService } from '../../providers/storage.service';
import { ChaseReportService } from '../../services/chasereport.service';
import { NewsService } from './../../services/news.service';


@Component({
    selector: 'chase-search',
    templateUrl: 'chasesearch.html',
    providers: [ChaseReportService, NewsService]
})
export class ChaseSearch {
    issueNo = "";
    state = "";
    start = PageDefault.startDate();
    end = PageDefault.endDate();
    lotteryCode = "_ALL";
    lotteryCodes = [];
    PageIndex = 1;
    type = '0';
    subUserName: string = '';
    subUserNames = [];
    tracks = {};
    username = this.config.getCurrentUser().UserName;
    listFlag: boolean = false;
    items = [];

    constructor(
        private viewCtrl: ViewController,
        private config: AppConfig,
        private navpar: NavParams,
        private storage: StorageService,
        private newsService: NewsService,
        private chasereport: ChaseReportService) {
        this.getAllLotterys();
        this.issueNo = navpar.data.issueNo != undefined ? navpar.data.issueNo : "";
        this.state = navpar.data.state != undefined ? navpar.data.state : "";
        this.start = navpar.data.startDate != undefined ? navpar.data.startDate : PageDefault.endNowDate();
        this.end = navpar.data.endDate != undefined ? navpar.data.endDate : PageDefault.endDate();
        this.lotteryCode = navpar.data.lotteryCode != undefined ? navpar.data.lotteryCode : "_ALL";
        this.subUserName = navpar.data.subUserName != undefined ? navpar.data.subUserName : "";
        this.PageIndex = 1;
        if (navpar.data.Type == '1' && navpar.data.Type) {
            this.type = '1';
            this.getSubUserNames();
        } else {
            this.type = '0';
        }
    }
    cons() {
    }

    //查询条件
    //TQQ 2016-12-30
    applyFilters() {
        this.tracks["issueNo"] = this.issueNo;
        this.tracks["state"] = this.state;
        this.tracks["startDate"] = this.start;
        this.tracks["endDate"] = this.end;
        this.tracks["lotteryCode"] = this.lotteryCode;
        this.tracks["PageIndex"] = 1;
        this.tracks["Type"] = this.type;
        this.tracks["subUserName"] = this.subUserName;
        this.dismiss(this.tracks)
    }
    //获取当前用户的下级列表
    //TQQ 2017-06-15
    getSubUserNames() {
        this.newsService.getSubUserNames().then(data => {
            if (!data || data.length < 1) {
                return;
            }
            this.subUserNames = [{ label: "请选择", value: "" }];
            data.forEach(u => {
                this.subUserNames.push({ label: u, value: u });
            });
            this.subUserName = this.subUserName ? this.subUserName : this.subUserNames[0].value;
            // this.subUserName=this.subUserName?this.subUserName:"";  
        });
    }



    getAllLotterys() {
        // this.chasereport.getAllLotterys().then(s => {
        //     this.lotteryCodes = s;
        // });
        var lotterys = this.storage.read<LotteryModel[]>("lotterys");
        if (lotterys != null) {
            this.lotteryCodes = lotterys;
        } else {
            this.chasereport.getAllLotterys().then(s => {
                this.lotteryCodes = s;
            });
        }
        this.lotteryCodes.splice(0, 0, { LotteryCode: "_ALL", LotteryName: "全部" });
    }

    //判断是个人或团队
    //chen 2017-08-16
    perTeam() {
        if (this.type == '1') {
            this.getSubUserNames();
        }
    }

    //关闭
    //TQQ 2016-12-30
    dismiss(data?: any) {
        this.viewCtrl.dismiss(data);
    }



}


// WEBPACK FOOTER //
// ./src/pages/chasereport/chasesearch.ts